import React, { createContext, useState, useContext } from 'react';

const PageTitleContext = createContext({
    pageTitle: '',
    setPageTitle: () => {},
    rightContent: null,
    setRightContent: () => {},
});

export const PageTitleProvider = ({ children }) => {
    const [pageTitle, setPageTitle] = useState('');
    const [rightContent, setRightContent] = useState(null);

    return (
        <PageTitleContext.Provider value={{ pageTitle, setPageTitle, rightContent, setRightContent }}>
            {children}
        </PageTitleContext.Provider>
    );
};

export const usePageTitle = () => useContext(PageTitleContext);

export default PageTitleContext;